import './Spoiler.scss'; // import './css/Spoiler.scss'

import React, { useState } from "react";

import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';


const Spoiler: React.FC<any> = (props: any) => {

    const [show, setShow] = useState<boolean>(props.show);

    let childrens = null;
    if (props.children && Array.isArray(props.children)) {
        childrens = props.children.map((component: any, i: number) => component);
    } else {
        childrens = props.children;
    }

    if (!childrens) {
        childrens = props.content;
    }


    let className = "spoiler ";

    if (show) {
        className += "show ";
    } else {
        className += "hide ";


        switch (props.type) {
            case 'hover': {
                className += 'hideHover ';
                break;
            }
            case 'active': {
                className += 'hideActive ';
                break;
            }
            case 'click':
            default: {
                className += 'hideClick ';
            }
        }

        switch (props.color) {
            case 'primary': {
                className += 'hidePrimary ';
                break;
            }
            case 'secondary': {
                className += 'hideSecondary ';
                break;
            }
            case 'success': {
                className += 'hideSuccess ';
                break;
            }
            case 'warning': {
                className += 'hideWarning ';
                break;
            }
            case 'danger': {
                className += 'hideDanger ';
                break;
            }
            case 'info': {
                className += 'hideInfo ';
                break;
            }
            case 'gray':
            default: {
            }
        }
    }

    if (props.class) {
        className = className + ' ' + props.class + ' ';
    }

    return (
        <>
            {
                show ?
                    <span className={className}
                        onClick={(e) => {
                            if (props.type && props.type === 'click') {
                                setShow(!show);
                            }
                            if (props.onClick) {
                                props.onClick(e);
                            }
                        }}


                        /* hideHover */
                        onMouseLeave={(e) => {
                            if (props.type && (props.type === 'hover' || props.type === 'active')) {
                                setShow(false);
                            }
                            if (props.onMouseLeave) {
                                props.onMouseLeave(e);
                            }
                        }}


                        /* hideActive */
                        onMouseUp={(e) => {
                            if (props.type && props.type === 'active') {
                                setShow(false);
                            }
                            if (props.onMouseUp) {
                                props.onMouseUp(e);
                            }
                        }}
                    >
                        {childrens}
                    </span>
                    :
                    <span className={className}
                        onClick={(e) => {
                            if (props.type && props.type === 'click') {
                                setShow(!show);
                            }
                            if (props.onClick) {
                                props.onClick(e);
                            }
                        }}

                        /* hideHover */
                        onMouseEnter={(e) => {
                            if (props.type && props.type === 'hover') {
                                // setTimeout(() => setShow(true), 200)
                                setShow(true);
                            }
                            if (props.onMouseEnter) {
                                props.onMouseEnter(e);
                            }
                        }}

                        /* hideActive */
                        onMouseDown={(e) => {
                            if (props.type && props.type === 'active') {
                                // setTimeout(() => setShow(true), 200)
                                setShow(true);
                            }
                            if (props.onMouseDown) {
                                props.onMouseDown(e);
                            }
                        }}
                    >
                        <span className="content">
                            {childrens}
                        </span>
                        <span className="eye">
                            <VisibilityRoundedIcon />
                        </span>
                    </span>
            }
        </>

    );
};
export default React.memo(Spoiler);